import { render, staticRenderFns } from "./slidesItem.vue?vue&type=template&id=0548e7fc&scoped=true&"
import script from "./slidesItem.vue?vue&type=script&lang=js&"
export * from "./slidesItem.vue?vue&type=script&lang=js&"
import style0 from "./slidesItem.vue?vue&type=style&index=0&id=0548e7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548e7fc",
  null
  
)

component.options.__file = "slidesItem.vue"
export default component.exports